import { useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Generic event tracker.
 * Returns an onClick handler: track(type, source, meta)()
 * or callable directly: track(type, source, meta)
 *
 * Fires:
 *   1. Backend event (/api/track/event)
 *   2. Google Analytics event (window.gtag) if available
 * Never blocks default navigation (fire-and-forget).
 */
export default function useEventTracking() {
  return useCallback((eventType, source, meta) => {
    const send = () => {
      try {
        axios.post(
          `${API}/track/event`,
          {
            event_type: eventType,
            source,
            page: typeof window !== "undefined" ? window.location.pathname : "",
            referrer: typeof document !== "undefined" ? document.referrer : "",
            meta: meta || {},
          },
          { timeout: 2000 }
        ).catch(() => {});
      } catch (_) { /* noop */ }

      try {
        if (typeof window !== "undefined" && typeof window.gtag === "function") {
          window.gtag("event", `${eventType}_click`, {
            event_category: "engagement",
            event_label: source,
          });
        }
      } catch (_) { /* noop */ }
    };
    // Return a handler so callers can use trackEvent("call", "hero") as onClick
    return send;
  }, []);
}
